/**
 * Upload Service
 * Handles all file upload related API calls (BunnyCDN)
 *
 * @module services/UploadService
 */

import BaseService from "./BaseService";
import { createApiClient } from "./apiClient";

class UploadService extends BaseService {
  constructor() {
    super("/bunny-upload");
    // Use a clean client without default Content-Type: application/json
    // This allows axios to automatically set multipart/form-data with boundary
    this.client = createApiClient();
  }

  async generateSignedUrl(data) {
    return this.post("generate-signed-put-url", data);
  }

  async uploadThumbnail(formData, onUploadProgress) {
    return this.post("bunny-thumbnail", formData, {
      onUploadProgress,
    });
  }

  async uploadVideo(formData, onUploadProgress) {
    return this.post("bunny-video", formData, {
      onUploadProgress,
    });
  }

  async uploadAudio(formData, onUploadProgress) {
    return this.post("bunny-audio", formData, {
      onUploadProgress,
    });
  }

  async uploadDocument(formData, onUploadProgress) {
    return this.post("bunny-document", formData, {
      onUploadProgress,
    });
  }
}

export default new UploadService();
